import { Grid } from '@mui/material'
import styles from './signup.module.scss'

// import GoogleIcon from '@mui/icons-material/Google'
import SignInForm from './SignInForm.jsx'
import AuthCommonCard from '../molecules/AuthCommonCard.jsx'
import AuthCommonForm from '../molecules/AuthCommonForm.jsx'
import { Link } from 'react-router-dom'

const SignInComp = () => {
	return (
		// <section className={styles.signInSection}>
		// 	<div className="container">
		// 		<div className={styles.inner}>
		// 			<Grid container alignItems={'unset'}>
		// 				<Grid size={{ xs: 12, sm: 6 }}>
		// 					<div className={styles.imageContainer}>
		// 						<img
		// 							src="/images/signup-img.png"
		// 							alt="signup-img.jpg"
		// 						/>
		// 					</div>
		// 				</Grid>
		// 				<SignInForm />
		// 			</Grid>
		// 			<div className={styles.bgImg}>
		// 				<img src="/images/clock-img.png" alt="clock-img.png" />
		// 			</div>
		// 		</div>
		// 	</div>
		// </section>
		<AuthCommonCard className={styles.signInSection}>
			<AuthCommonForm
				title={'sign in'}
				subTitle={
					<>
						No Account?{' '}
						<Link to="/signup" data-cy="go-to-sign-up">
							Sign up
						</Link>
					</>
				}
			>
				<SignInForm />
			</AuthCommonForm>
		</AuthCommonCard>
	)
}

export default SignInComp
